export default __webpack_public_path__ + "static/media/break23.fc65cfee.jpg";